import {FaExternalLinkAlt} from "react-icons/fa";

import {TooltipIconRA} from "@/components/overlay/TooltipIconRA.tsx";
import {cropWithEllipsis} from "@/lib/displayUtils.ts";
import {RUMTableSegment} from "@/lib/queries/rum.ts";

interface URLGroupCellProps {
  v: RUMTableSegment;
  onURLClick: (url: string) => void;
}

export const URLGroupCell = ({v, onURLClick}: URLGroupCellProps) => {
  if (!v.URLGroup) {
    return "undefined";
  }

  const isURL = v.URLGroup.startsWith("http");
  return (
    <span className="d-flex">
      <button className="btn btn-link btn-sm p-0 text-decoration-none me-2" onClick={() => onURLClick(v.URLGroupHash)}>
        {cropWithEllipsis(v.URLGroup)}
      </button>
      {isURL && (
        <a className="d-flex" href={v.URLGroup} target="_blank" rel="noopener noreferrer">
          |
          <TooltipIconRA className="ms-2 align-text-top" title="Open in a new tab" icon={FaExternalLinkAlt} />
        </a>
      )}
    </span>
  );
};
